export const formatAmount = (number: number, fixed?: boolean): string =>
  Intl.NumberFormat('ru-Ru', {
    currency: 'RUB',
    ...(fixed
      ? { maximumFractionDigits: 0 }
      : { maximumFractionDigits: 2, minimumFractionDigits: 2 }),
  }).format(number);

export const formatPrice = (amount: number): string =>
  `${formatAmount(amount, true)} ₽`;

export const toDate = (date: string | null | number | undefined | Date) =>
  date ? new Date(date) : null;
